import {
  useFetchData,
  useParseRouteActions,
} from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { recalcReportFields } from "../ui/LmsSharedForms";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";
import { Header } from "semantic-ui-react";

const MainTable = () => {
  const actionButtons = ["add", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="/accounting/global-remittance-weekly"
      deleteSuffix="/accounting/global-remittance-weekly"
      sortable={["Buyer", "Seller"]} 
      columnLabelsDictionary={{
        servicingFeeToClsiinotPaidIn2: "Servicing Fee To CLSII Not Paid In2",
        toBcfallRemainingAmounts: "To BCF All Remaining Amounts"
      }}
    />
  );
};

const editWeeklyRecalcReportFormFields = (myForm) => {
  myForm.addComponent(<Header size="small" color="red" textAlign="center" className="lms-form-top-header">Borrowing Base Data Calculation is in progress</Header>); 
  myForm.addCenteredGroup([
    myForm.getDropdownField("LP", "/metadata/list-lp-organizations", {
      name: "lpOrganizationId",
      disabled: true
    }),

    myForm.getBlankField(),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Buyer", { required: true, disabled: true }),
    myForm.getInputField("Seller", { required: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Servicer", { required: true, disabled: true }),
    myForm.getInputField("Custodian", { required: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Diligence Agent", {
      required: true,
      disabled: true,
    }),
    
    myForm.getInputField("Account Bank", {  
      required: true,
      disabled: true,
    }),
  ]);

  myForm.addDividerField();
  myForm.addCenteredGroup([
    myForm.getCalendarField("Recalculation Date", { required: true, disabled: true }),
    myForm.getBlankField(),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Period Start", { required: true, disabled: true }),
    myForm.getCalendarField("Period End", { required: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Revolving Period End Date", { required: true, disabled: true }),
    myForm.getCalendarField("Amortization Period End Date", { required: true, disabled: true }),
  ]);

  myForm.addDividerField();
  myForm.addCenteredGroup([
    myForm.getInputField("Cash Balance In Cash Management Account", {
      required: true,
      disabled: true,
      wrapLabel:true
    }),

    myForm.getInputField("Cash Balance", {
      required: true,
      disabled: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Interest Reserve Balance", {
      required: true,
      disabled: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField(
      "To the Interest Reserve Account, until the amount on deposit in the Interest Reserve Account shall equal the Interest Reserve Account Minimum Balance",
      {
        name: "interestReserve",
        required: true,
        disabled: true,
        wrapLabel:true,
      }
    ),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField(
      "To Buyer - if a Borrowing Base Deficiency shall exist, to Buyer, to reduce the Purchase Price of all Purchased Assets on a pro rata basis, until such Borrowing Base Deficiency shall have been cured",
      {
        name: "borrowingBaseDeficiency",
        required: true,
        disabled: true,
        wrapLabel:true,
      }
    ),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField(
      "To Buyer - to reduce the Purchase Price of all Purchased Assets on a pro rata basis, up to the Required Amortization Amount, until the Aggregate Outstanding Purchase Price has been reduced to zero",
      {
        name: "principalDue",
        required: true,
        disabled: true,
        wrapLabel:true,
      }
    ),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField(
      "To Buyer - on account of all costs, expenses, indemnification amounts and fees incurred or charged by Buyer under this Agreement or the other Principal Agreements that are due and owing (in each case to the extent not paid by Seller)",
      {
        name: "buyerCostsOrFees",
        required: true,
        disabled: true,
        wrapLabel:true,
      }
    ),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Cash Waiting To Be Remaining", {
      required: true,
      disabled: true
    }),

    myForm.getInputField("To BCF All Remaining Amounts", {
      name: "toBcfallRemainingAmounts",
      required: true,
      disabled: true
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Remaining Cash Balance", {
      required: true,
      disabled: true
    }),

    myForm.getBlankField(),
  ]);

  myForm.addDividerField();
  myForm.addCenteredGroup([
    myForm.getDropdownField("Global Remittance Status", "/metadata/list-global-remittance-statuses", {
      name: "globalRemittanceStatusId",
      required: true,
      disabled: true
    }),

    myForm.getCalendarField("Payment Confirmation Received On", {
      name: "paymentConfirmationReceivedOn",
      disabled: true
    }),
  ]);

  return myForm;
};

const EditAccountingWeeklyRecalcReportForm = ({ id }: IdProps) => {
  if (FeatureFlags.IS_DEBUG) {
    console.log(id);
  }

  const [{ data = {}, isLoading, error }] = useFetchData(`/accounting/global-remittance-weekly/${id}`);
  const myForm = editWeeklyRecalcReportFormFields(
    new BCFormController(data, { submitSuffix: "/accounting/global-remittance-weekly", blankWidth: 4 })
  ); 

  const formActions = ["close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddAccountingWeeklyRecalcReportForm = () => {
  const [{ data = {}, isLoading, error }] = useFetchData("/accounting/global-remittance-weekly-initial-data");
  const myForm = new BCFormController(data, { submitSuffix: "/accounting/global-remittance-weekly", blankWidth: 5, submitMethod: "POST" });
  recalcReportFields(myForm, true);
  const formActions = [
    { text: "Get Borrowing Base Data", icon: GlobalConstants.Icons.SAVE, action:"save-close" },
    "close",
  ];
  
  return <LmsFormGenerator 
    myForm={myForm} 
    actions={formActions} 
    error={error} 
    isLoading={isLoading} 
    submitConfirmationMessage="Borrowing Base data calculation will take some time. We will inform you by email."
  />;
};

const LmsAccountingWeeklyRecalcReport = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
    useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddAccountingWeeklyRecalcReportForm />}
      {isEdit && <EditAccountingWeeklyRecalcReportForm id={id} />}
    </>
  );
};

export default LmsAccountingWeeklyRecalcReport;